import "../../utils/tailwind.css";
import { PageProvider, useFooterProvider } from "./provider";
import { Accordion } from "react-bootstrap";
import Label from "../../components/label";
import Section from "../../components/section";
import { FormikInput } from "../../components/input";
import Button from "../../components/Buttons";
import { Formik, Form, FieldArray } from "formik";
import Plus from "../../components/svg/plus";
import Trash from "../../components/svg/trash";
import ImageUploader from "../../components/upload-image";

export default function ContactForm() {
  return (
    <div className="p-3">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const { initialValues, handleSubmit,  } = useFooterProvider();

  return (
    <Section className="h-[80vh] overflow-y-auto">
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        enableReinitialize>
        {({ values, setFieldValue }) => (
          <Form>
            <Accordion defaultActiveKey="0">
              {/* CTA Section */}
              <Accordion.Item eventKey="0">
                <Accordion.Header>CTA Details</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                    <div className="flex flex-col">
                      <Label label="Heading" />
                      <FormikInput name="heading" rootClassName="w-full" />
                    </div>
                    <div className="flex flex-col">
                      <Label label="Subheading" />
                      <FormikInput name="sub_heading" rootClassName="w-full" />
                    </div>
                    <div className="flex flex-col">
                      <Label label="CTA Label" />
                      <FormikInput name="cta_label" rootClassName="w-full" />
                    </div>
                    <div className="flex flex-col">
                      <Label label="CTA Redirect Link" />
                      <FormikInput
                        name="cta_redirect_link"
                        rootClassName="w-full"
                      />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              {/* Socials Section */}
              <Accordion.Item eventKey="1">
                <Accordion.Header>Socials</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-2 gap-3">
                    <div className="flex flex-col">
                      <Label label="Heading" />
                      <FormikInput
                        name="socials.heading"
                        rootClassName="w-full"
                      />
                    </div>
                    <div className="flex flex-col">
                      <Label label="Subheading" />
                      <FormikInput
                        name="socials.sub_heading"
                        rootClassName="w-full"
                      />
                    </div>
                  </div>

                  {/* FieldArray for Socials List */}
                  <div className="flex justify-end mt-3">
                    <div
                      className="bg-black p-1 rounded-full cursor-pointer"
                      onClick={() =>
                        setFieldValue("socials.socials", [
                          ...values.socials.socials,
                          { heading: "", sub_heading: "", logo: "" },
                        ])
                      }>
                      <Plus className="text-white" />
                    </div>
                  </div>

                  <div className="mt-3 overflow-x-auto">
                    <table className="w-full border-collapse border border-gray-300">
                      <thead className="bg-gray-200">
                        <tr>
                          <th className=" font-normal px-4 py-2 text-left">
                            Heading
                          </th>
                          <th className="font-normal px-4 py-2 text-left">Link</th>
                          <th className="font-normal px-4 py-2 text-left">Logo</th>
                          <th className="font-normal px-4 py-2 text-left">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <FieldArray name="socials.socials">
                          {({ remove }) =>
                            values.socials.socials.map((item, index) => (
                              <tr key={index}>
                                <td className="border px-4 py-2">
                                  <FormikInput
                                    name={`socials.socials.${index}.heading`}
                                    rootClassName="w-full"
                                  />
                                </td>
                                <td className="border px-4 py-2">
                                  <FormikInput
                                    name={`socials.socials.${index}.link`}
                                    rootClassName="w-full"
                                  />
                                </td>
                                <td className="border px-4 py-2">
                                  <ImageUploader
                                    imageUrl={
                                      values.socials.socials[index].logo
                                    }
                                    onChange={(res) =>
                                      setFieldValue(
                                        `socials.socials.${index}.logo`,
                                        res?.data?.file_url
                                      )
                                    }
                                  />
                                </td>
                                <td className="border px-4 py-2 text-center cursor-pointer">
                                  <Trash onClick={() => remove(index)} />
                                </td>
                              </tr>
                            ))
                          }
                        </FieldArray>
                      </tbody>
                    </table>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="2">
                <Accordion.Header>Other Details</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-2 gap-3">
                    <div className="flex flex-col">
                      <Label label="Business heading" />
                      <FormikInput
                        name="business_details.heading"
                        rootClassName="w-full"
                      />
                    </div>
                    <div className="flex flex-col">
                      <Label label="Business email" />
                      <FormikInput
                        name="business_details.email"
                        rootClassName="w-full"
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-3 mt-3">
                    <div className="flex flex-col">
                      <Label label="Business email" />
                      <FormikInput
                        name="business_details.contact"
                        rootClassName="w-full"
                      />
                    </div>
                    <div className="flex flex-col">
                      <Label label="Quick links heading" />
                      <FormikInput
                        name="quick_links_details.heading"
                        rootClassName="w-full"
                      />
                    </div>
                  </div>

                  <div className="flex justify-end mt-3">
                    <div
                      className="bg-black p-1 rounded-full cursor-pointer"
                      onClick={() =>
                        setFieldValue("quick_links_details.quick_links", [
                          ...values.quick_links_details.quick_links,
                          { label: "", redirect_link: "" },
                        ])
                      }>
                      <Plus className="text-white" />
                    </div>
                  </div>

                  <div className="mt-3 overflow-x-auto">
                    <table className="w-full border-collapse border border-gray-300">
                      <thead className="bg-gray-200">
                        <tr>
                          <th className="font-normal px-4 py-2 text-left">Label</th>
                          <th className="font-normal px-4 py-2 text-left">
                            Redirect link
                          </th>
                          <th className="font-normal px-4 py-2 text-left">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <FieldArray name="quick_links_details.quick_links">
                          {({ remove }) =>
                            values.quick_links_details.quick_links.map(
                              (item, index) => (
                                <tr key={index}>
                                  <td className="border px-4 py-2">
                                    <FormikInput
                                      name={`quick_links_details.quick_links.${index}.label`}
                                      rootClassName="w-full"
                                    />
                                  </td>
                                  <td className="border px-4 py-2">
                                    <FormikInput
                                      name={`quick_links_details.quick_links.${index}.redirect_link`}
                                      rootClassName="w-full"
                                    />
                                  </td>
                                  <td className="border px-4 py-2 text-center cursor-pointer">
                                    <Trash onClick={() => remove(index)} />
                                  </td>
                                </tr>
                              )
                            )
                          }
                        </FieldArray>
                      </tbody>
                    </table>
                  </div>
                  <div className="grid grid-cols-2 gap-3 mt-3 mb-4 ">
                    <div className="flex flex-col">
                      <Label label="Address title" />
                      <FormikInput
                        name="address_details.title"
                        rootClassName="w-full"
                      />
                    </div>
                    <div className="flex flex-col">
                      <Label label="Address" />
                      <FormikInput
                        name="address_details.address"
                        rootClassName="w-full"
                      />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

            {/* Submit Button */}
            <div className="fixed bottom-0 left-0 w-full bg-white flex justify-end items-center py-3 pr-4 shadow-md">
              <Button type="submit">Save</Button>
            </div>
          </Form>
        )}
      </Formik>
    </Section>
  );
}
